export default "__VITE_ASSET__BgteZePs__"